<template>
  <div v-if="visible" id="tab-sub-bill">
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <div>
          <el-dropdown
            no="1"
            :class="readonly?'not-click':''"
            split-button
            type="primary"
            @click="commandHandle(command1)"
            @command="p=>{command1=p;commandHandle(command1);}"
          >
            {{ command1 }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.CodeSearching')">{{ $t('SeaExport.CodeSearching') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromTheLastTime')">{{ $t('SeaExport.CopyFromTheLastTime') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromOtherBill')">{{ $t('SeaExport.CopyFromOtherBill') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyCargoDescriptionAndMarks')">{{ $t('SeaExport.CopyCargoDescriptionAndMarks') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            v-show="Boolean(form.uuid)"
            no="2"
            :disabled="btnPrintDisabled"
            type="primary"
            @click="originalPrint"
          >{{ form.releaseType === 1 ? $t('SeaExport.PrintTheOriginalBl') : $t('SeaExport.TelexRelease') }}</el-button>
          <el-button v-show="readonly && Boolean(form.uuid)" v-permission="['button_M/HBL_confirmBL']" no="ConfirmChecking" type="primary" @click="pm.confirmBL()">{{ $t('SeaExport.ConfirmChecking') }}</el-button>
          <el-button v-show="readonly&&form.state==2" no="3" type="primary" @click="pm.onState()">{{ $t('SeaExport.Unlock') }}</el-button>
          <el-button v-show="readonly && Boolean(form.uuid)" v-permission="['button_M/HBL_identification']" no="IdentificationList" type="primary" @click="onIdentificationList">{{ $t('SeaExport.IdentificationList') }}</el-button>
          <el-checkbox
            :value="form.state===2"
            :disabled="true"
            style="margin-left: 10px"
          >{{ $t('SeaExport.Locked') }}</el-checkbox>
          <el-checkbox v-model="form.oversea" no="4" style="margin-left: -20px;" :disabled="readonly">{{ $t('SeaExport.BlBeReleased') }}</el-checkbox>
          <el-checkbox v-model="form.manifestEDI" no="5" style="margin-left: -20px;" :disabled="readonly">{{ $t('SeaExport.ManifestEdi') }}</el-checkbox>
          <el-checkbox v-model="form.printParam1" no="6" style="margin-left: -20px;" :disabled="readonly">Part of</el-checkbox>
          <el-checkbox v-model="form.printParam2" no="7" style="margin-left: -20px;" :disabled="readonly">{{ $t('SeaExport.ClauseOfNoWoodPackingMaterial') }}</el-checkbox>
          <el-checkbox
            v-model="form.printParam3"
            no="8"
            style="margin-left: -20px;"
            :disabled="readonly"
            @change="val=>{pm.chargeContainer()}"
          >{{ $t('SeaExport.ShowNumberOfPackagesGrossWeightAndMeasurementAfterCNTRNOSSEALNOS') }}</el-checkbox>
        </div>
      </div>
    </div>
    <div style="width: fit-content" class="tab-sub-bill-class">
      <div style="display: flex">
        <div class="section form-column">
          <el-form :disabled="readonly" label-width="60px" label-position="right" style="height:100%">
            <span class="title">{{ $t('SeaExport.ConsigneeShipperAndNotifyInfo') }}</span>
            <el-form-item :label="$t('SeaExport.Shipper')" class="auto-width">
              <div style="display: flex">
                <el-input v-model="form.shipperCode" no="9" style="flex: 1;width: 129px" />
                <el-button no="10" type="primary" style="margin-left: 6px" @click="pm.onClear(1)">{{ $t('SeaExport.Reset') }}</el-button>
              </div>
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.shipperLine1"
                no="11"

                :auto-uppercase="notUppercaseShipperConsigneNotify"
                @dblclick.native="showShipperDialog"
                @change="CargoDocUtil.sftAddrChangeWrap('shipperLine1','shipperLine2',maxChars)"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.shipperLine2"
                no="12"

                :auto-uppercase="notUppercaseShipperConsigneNotify"
                @dblclick.native="showShipperDialog"
                @change="CargoDocUtil.sftAddrChangeWrap('shipperLine2','shipperLine3',maxChars)"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.shipperLine3"
                no="13"

                :auto-uppercase="notUppercaseShipperConsigneNotify"
                @dblclick.native="showShipperDialog"
                @change="CargoDocUtil.sftAddrChangeWrap('shipperLine3','shipperLine4',maxChars)"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.shipperLine4"
                no="14"

                :auto-uppercase="notUppercaseShipperConsigneNotify"
                @dblclick.native="showShipperDialog"
                @change="CargoDocUtil.sftAddrChangeWrap('shipperLine4','shipperLine5',maxChars)"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.shipperLine5"
                no="15"

                :auto-uppercase="notUppercaseShipperConsigneNotify"
                @dblclick.native="showShipperDialog"
                @change="CargoDocUtil.sftAddrChangeWrap('shipperLine5','shipperLine6',maxChars)"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.shipperLine6"
                no="16"

                :auto-uppercase="notUppercaseShipperConsigneNotify"
                @dblclick.native="showShipperDialog"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.shipperLine7"
                no="160"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                @dblclick.native="showShipperDialog"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Consignee')">
              <div style="display: flex">
                <el-input v-model="form.consigneeCode" no="17" style="flex:1" />
                <el-button no="18" type="primary" style="margin-left: 6px;" @click="pm.onClear(2)">{{ $t('SeaExport.Reset') }}</el-button>
              </div>
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.consigneeLine1"
                no="19"

                :auto-uppercase="notUppercaseShipperConsigneNotify"
                @dblclick.native="showConsigneeDialog"
                @change="CargoDocUtil.sftAddrChangeWrap('consigneeLine1','consigneeLine2',maxChars)"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.consigneeLine2"
                no="20"

                :auto-uppercase="notUppercaseShipperConsigneNotify"
                @dblclick.native="showConsigneeDialog"
                @change="CargoDocUtil.sftAddrChangeWrap('consigneeLine2','consigneeLine3',maxChars)"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.consigneeLine3"
                no="21"

                :auto-uppercase="notUppercaseShipperConsigneNotify"
                @dblclick.native="showConsigneeDialog"
                @change="CargoDocUtil.sftAddrChangeWrap('consigneeLine3','consigneeLine4',maxChars)"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.consigneeLine4"
                no="22"

                :auto-uppercase="notUppercaseShipperConsigneNotify"
                @dblclick.native="showConsigneeDialog"
                @change="CargoDocUtil.sftAddrChangeWrap('consigneeLine4','consigneeLine5',maxChars)"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.consigneeLine5"
                no="23"

                :auto-uppercase="notUppercaseShipperConsigneNotify"
                @dblclick.native="showConsigneeDialog"
                @change="CargoDocUtil.sftAddrChangeWrap('consigneeLine5','consigneeLine6',maxChars)"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.consigneeLine6"
                no="24"

                :auto-uppercase="notUppercaseShipperConsigneNotify"
                @dblclick.native="showConsigneeDialog"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.consigneeLine7"
                no="240"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                @dblclick.native="showConsigneeDialog"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.NotifyParty')" class="auto-width">
              <div>
                <el-input v-model="form.notifyCode" no="25" style="flex: 1" />
                <div style="margin-top: 5px">
                  <el-button no="26" type="primary" @click="pm.onClear(3)">{{ $t('SeaExport.Reset') }}</el-button>
                  <el-button no="27" type="primary" style="margin-left: 6px;" @click="pm.onCopy_consignee()">{{ $t('SeaExport.CopyTheConsignee') }}</el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.notifyLine1"
                no="28"

                :auto-uppercase="notUppercaseShipperConsigneNotify"
                @dblclick.native="showNotifyDialog"
                @change="CargoDocUtil.sftAddrChangeWrap('notifyLine1','notifyLine2',maxChars)"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.notifyLine2"
                no="29"

                :auto-uppercase="notUppercaseShipperConsigneNotify"
                @dblclick.native="showNotifyDialog"
                @change="CargoDocUtil.sftAddrChangeWrap('notifyLine2','notifyLine3',maxChars)"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.notifyLine3"
                no="30"

                :auto-uppercase="notUppercaseShipperConsigneNotify"
                @dblclick.native="showNotifyDialog"
                @change="CargoDocUtil.sftAddrChangeWrap('notifyLine3','notifyLine4',maxChars)"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.notifyLine4"
                no="31"

                :auto-uppercase="notUppercaseShipperConsigneNotify"
                @dblclick.native="showNotifyDialog"
                @change="CargoDocUtil.sftAddrChangeWrap('notifyLine4','notifyLine5',maxChars)"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.notifyLine5"
                no="32"

                :auto-uppercase="notUppercaseShipperConsigneNotify"
                @dblclick.native="showNotifyDialog"
                @change="CargoDocUtil.sftAddrChangeWrap('notifyLine5','notifyLine6',maxChars)"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.notifyLine6"
                no="33"

                :auto-uppercase="notUppercaseShipperConsigneNotify"
                @dblclick.native="showNotifyDialog"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.notifyLine7"
                no="330"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                @dblclick.native="showNotifyDialog"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <div style="display: flex">
                <span style="color:#404144">{{ $t('SeaExport.AgentInfo') }}</span>

                <div style="flex: 1;text-align: right">
                  <el-button no="34" type="primary" style="margin-left: 6px;" @click="pm.onClear(4)">{{ $t('SeaExport.Reset') }}</el-button>
                  <el-dropdown
                    no="35"
                    style="margin-left: 6px;vertical-align: bottom;"
                    :class="readonly?'not-click':''"
                    split-button
                    type="primary"
                    @click="commandHandle(command3)"
                    @command="p=>{command3=p;commandHandle(command3)}"
                  >
                    {{ command3 }}
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :command="$t('SeaExport.CopyMblConsignee')">{{ $t('SeaExport.CopyMblConsignee') }}</el-dropdown-item>
                      <el-dropdown-item :command="$t('SeaExport.CopyNominatedAgentInfo')">{{ $t('SeaExport.CopyNominatedAgentInfo') }}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.agentPartyLine1"
                no="36"

                :auto-uppercase="isUppercase"
                @dblclick.native="showAgentPartyDialog"
                @change="CargoDocUtil.sftAddrChangeWrap('agentPartyLine1','agentPartyLine2',maxChars)"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.agentPartyLine2"
                no="37"

                :auto-uppercase="isUppercase"
                @dblclick.native="showAgentPartyDialog"
                @change="CargoDocUtil.sftAddrChangeWrap('agentPartyLine2','agentPartyLine3',maxChars)"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.agentPartyLine3"
                no="38"

                :auto-uppercase="isUppercase"
                @dblclick.native="showAgentPartyDialog"
                @change="CargoDocUtil.sftAddrChangeWrap('agentPartyLine3','agentPartyLine4',maxChars)"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.agentPartyLine4"
                no="39"

                :auto-uppercase="isUppercase"
                @dblclick.native="showAgentPartyDialog"
                @change="CargoDocUtil.sftAddrChangeWrap('agentPartyLine4','agentPartyLine5',maxChars)"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.agentPartyLine5"
                no="40"

                :auto-uppercase="isUppercase"
                @dblclick.native="showAgentPartyDialog"
                @change="CargoDocUtil.sftAddrChangeWrap('agentPartyLine5','agentPartyLine6',maxChars)"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.agentPartyLine6"
                no="41"

                :auto-uppercase="isUppercase"
                @dblclick.native="showAgentPartyDialog"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-input
                v-model="form.agentPartyLine7"
                no="410"
                :auto-uppercase="isUppercase"
                @dblclick.native="showAgentPartyDialog"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form :disabled="readonly" label-width="100px" label-position="right" style="height:100%">
            <span class="title">{{ $t('SeaExport.CargoInfo') }}</span>
            <el-form-item :label="$t('SeaExport.NumberOfPackagesOnBl')">
              <auto-number-input
                v-model="form.quantity"
                no="42"
                :precision="0"
                :min="0"
                @change="hblNbr2Change"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Package')">
              <cargo-packing-select
                :default-value="form.packing"
                placeholder=" "
                style="width:100%;"
                @change="p=>{form.packing=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Pieces2')">
              <auto-number-input
                v-model="form.insideQuantity"
                :precision="0"
                :min="0"
                @change="hblNbr2Change"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Weight')">
              <div style="display: flex">
                <el-input-number
                  v-model="form.weight"
                  :precision="3"
                  :controls="false"
                  style="flex: 1"
                  @change="hblNbr2Change"
                />
                <span>KGS</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Cubage')">
              <div style="display: flex">
                <el-input-number
                  v-model="form.cubage"
                  :precision="3"
                  :controls="false"
                  style="flex:1"
                  @change="hblNbr2Change"
                />
                <span>CBM</span>
              </div>
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <div style="display: flex;justify-content: space-between">
                <span>{{ $t('SeaExport.EnglishDescriptionOfGoods') }}</span>
                <el-button
                  v-show="isEdit"
                  no="43"
                  type="primary"
                  style="float:right"
                  @click="pm.getMBLInfo('EName')"
                >{{ $t('SeaExport.CopyEnglishDescriptionOfGoodsFromMbl') }}</el-button>
              </div>
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-rich-textarea
                v-model="form.cargoEnglishName"
                no="44"
                :disabled="!isEdit"
                :text-chars="0"
                :warning-count="-1"
                wrap-symbol="r"
                :auto-uppercase="isUppercaseByConfig"
                auto-half-word
                style="height: 110px"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),form.cargoEnglishName,val=>{form.cargoEnglishName=val},isUppercaseByConfig,{autoHalfWord: true,autoUppercase:true})"
              />
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <div style="display: flex;justify-content: space-between">
                <span>{{ $t('SeaExport.Marks') }}</span>
                <el-button
                  v-show="isEdit"
                  no="45"
                  type="primary"
                  style="float:right;margin-left:5px"
                  @click="pm.getMBLInfo('mark')"
                >{{ $t('SeaExport.CopyMarksFromMbl') }}</el-button>
              </div>
            </el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <cargo-rich-textarea
                v-model="form.mark"
                no="46"
                :text-chars="0"
                :warning-count="-1"
                wrap-symbol="r"
                :auto-uppercase="isUppercaseByConfig"
                auto-half-word
                style="height: 110px"
                :disabled="!isEdit"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),form.mark,val=>{form.mark=val},isUppercaseByConfig,{autoHalfWord: true,autoUppercase:true})"
              />
            </el-form-item>
            <el-form-item label-width="0"><span>{{ $t('SeaExport.CapitalizedNumbersOfPackages') }}</span></el-form-item>
            <el-form-item label-width="0" class="auto-width">
              <el-input :disabled="true" :value="txtQuantitySum" />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form :disabled="readonly" label-width="100px" label-position="right" style="height:100%">
            <span class="title">{{ $t('SeaExport.TransportInfo') }}</span>
            <el-form-item label="HB/L NO.">
              <el-input v-model="form.hblNbr2" no="47" @input="hblNbr2Change" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BillOfLadingNumber')">
              <el-input v-model="form.serialNo" no="48" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.VesselAndVoyage')">
              <el-input :disabled="true" :value="txtFirstVesselVoyage" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DateOfDeparture')">
              <el-input :value="moment(job.etd).format('YYYY-MM-DD')" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfReceiptOnBl')">
              <cargo-advance-select
                :disabled="true"
                :select-type="TYPE_NAMES.basic_data_Seaport"
                filterable
                :default-value="form.dispatchingPlaceCode||''"
                tag-name="englishName"
                @parentCallBack="p=>{pm.portChange(p, 'dispatchingPlace')}"
              />
              <el-input v-model="form.dispatchingPlace" no="49" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortOfLoadingOnBl')">
              <cargo-advance-select
                :disabled="true"
                :select-type="TYPE_NAMES.basic_data_Seaport"
                filterable
                :default-value="form.loadingPortCode||''"
                tag-name="englishName"
                no="loadingPortCode"
                @parentCallBack="p=>{pm.portChange(p, 'loadingPort')}"
              />
              <el-input v-model="form.loadingPort" no="50" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortOfDischargeOnBl')">
              <cargo-advance-select
                :disabled="true"
                :select-type="TYPE_NAMES.basic_data_Seaport"
                filterable
                :default-value="form.dischargingPortCode||''"
                tag-name="englishName"
                no="dischargingPortCode"
                @parentCallBack="p=>{pm.portChange(p, 'dischargingPort')}"
              />
              <el-input v-model="form.dischargingPort" no="51" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfDeliveryOnBl')">
              <cargo-advance-select
                :disabled="true"
                :select-type="TYPE_NAMES.basic_data_Seaport"
                filterable
                :default-value="form.destinationPortCode||''"
                tag-name="englishName"
                no="destinationPortCode"
                @parentCallBack="p=>{pm.portChange(p, 'destinationPort')}"
              />
              <el-input v-model="form.destinationPort" no="52" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BlFinalDestination')">
              <el-input v-model="form.destinationPlace" no="53" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MethodOfHblPayment')">
              <cargo-advance-select
                no="54"
                :select-type="TYPE_NAMES.basic_data_PaymentTerm"
                filterable
                :allow-create="true"
                :default-value="form.paymentTerm"
                style="width:100%;"
                @parentCallBack="p=>{form.paymentTerm = p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfHblPayment2')">
              <el-input :disabled="true" :value="form.paymentPlaceBL" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TransportationClause')">
              <el-input :disabled="true" :value="job.freightTermHBL" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.NoOfOriginalBls')">
              <el-input :disabled="true" :value="form.blNumber" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfIssue')">
              <el-input :disabled="true" :value="form.signPlaceBL" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DateOfIssue')">
              <el-date-picker v-model="form.signDateBL" no="55" type="date" value-format="yyyy-MM-dd" style="width: 100%;" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BlRemarks')">
              <el-input
                v-model="form.remarks"
                no="56"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.BlRemarks'),form.remarks,val=>{form.remarks=val})"
              />
            </el-form-item>
            <el-form-item label="ALSO NOTIFY">
              <cargo-rich-textarea
                v-model="form.alsoNotify"
                no="57"
                :disabled="readonly"
                :text-chars="0"
                wrap-symbol="r"
                auto-uppercase
                auto-half-word
                style="height: 110px;"
                @dblclick.native="showAdvanceTextDialog('ALSO NOTIFY',form.alsoNotify,val=>{form.alsoNotify=val.toUpperCase()},notUppercaseShipperConsigneNotify,{warningCount:45,autoHalfWord: true,autoUppercase:true})"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form label-width="100px" label-position="right" style="height:100%">
            <span class="title">{{ $t('SeaExport.OtherInfo') }}</span>
            <el-form-item v-show="job.typeVirtualHbl===VirtualBillType.NORMAL_VIRTUAL_BILL_TYPE.code" label-width="0" class="auto-width">
              <cargo-ag-grid
                no="58"
                :grid-options="bill.gridOptions"
                :column-defs="bill.columnDefs"
                :row-data="billFinalRowData"
                style="width:100%;height:200px"
                @gridReady="params=>{bill.gridApi=params.api}"
              />
              <div style="padding:5px 0">
                <div style="float:right">
                  <el-button no="59" :disabled="readonly" type="primary" @click="pm.newSubBillHandler()">{{ $t('SeaExport.Add') }}</el-button>
                  <el-button no="60" :disabled="readonly" type="danger" @click="pm.delSubBillHandler()">{{ $t('SeaExport.Delete') }}</el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item v-show="job.typeVirtualHbl===VirtualBillType.MERGE_VIRTUAL_BILL_TYPE.code" label-width="0" class="auto-width">
              <cargo-ag-grid
                no="66"
                config-module="2023121501"
                :disabled="readonly"
                :grid-options="virtualMergeBill.gridOptions"
                :column-defs="virtualMergeBill.columnDefs"
                :row-data="virtualMergeBillFinalRowData"
                style="width:100%;height:200px"
                @gridReady="params=>{virtualMergeBill.gridApi=params.api}"
              />
              <div style="padding:5px 0">
                <div style="float:right">
                  <el-button no="67" :disabled="readonly" type="primary" @click="pm.joinVirtualMergeBillHandler()">{{ $t('SeaExport.Join') }}</el-button>
                  <el-button no="68" :disabled="readonly" type="danger" @click="pm.removeVirtualMergeBillHandler()">{{ $t('SeaExport.Delete') }}</el-button>
                </div>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BlType')">
              <el-select
                no="61"
                :disabled="readonly"
                :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')"
                :value="form.releaseType||''"
                @input="val=>{form.releaseType=val}"
                @change="val=>{pm.cmbreleaseTypeMBLChangeHandler(val)}"
              >
                <el-option
                  v-for="(item,index) in blModeList"
                  :key="index"
                  :label="item.name"
                  :value="item.serialNumber"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BlType2')">
              <cargo-advance-select
                ref="orderFormType"
                no="62"
                :disabled="readonly"
                :select-type="TYPE_NAMES.basic_data_OrderFormType"
                filterable
                :default-value="form.issuerBL"
                style="width:100%;"
                @parentCallBack="p=>{pm.cmbissuerHBLChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.VirtualBillType')">
              <el-select
                :value="job.typeVirtualHbl||0"
                :disabled="readonly||cmbtypeHAWB2Disabled"
                no="typeVirtualHbl"
                :clearable="false"
                @input="val=>{pm.typeVirtualHblChangeHandler(val)}"
              >
                <el-option
                  v-for="(item,index) in VIRTUAL_BILL_TYPES"
                  :key="index"
                  :label="item.chineseName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ParamRemark')">
              <el-select v-model="form.printParam4" no="63" :disabled="readonly" :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')" filterable allow-create>
                <el-option
                  v-for="(item,index) in pm.printParam4Type"
                  :key="index"
                  :label="item.label"
                  :value="item.data"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.GenerationOfABillOfLading')">
              <el-select v-model="form.printParam5" no="64" :disabled="readonly" :placeholder="readonly ? '' : $t('CargoMsg.Cargo_PleaseSelect')">
                <el-option
                  v-for="(item,index) in pm.printParam5Type"
                  :key="index"
                  :label="item.label"
                  :value="item.data"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-show="job.containerLoadType==='BB'" :label="$t('SeaExport.CNTRNOSSEALNOS')">
              <cargo-rich-textarea
                v-model="form.container"
                no="65"
                :disabled="readonly"
                :text-chars="0"
                wrap-symbol="r"
                style="height: 110px;"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.CNTRNOSSEALNOS'),form.container,val=>{form.container=val},true,{warningCount:45})"
              />
            </el-form-item>
            <!-- 提单确认状态 -->
            <el-form-item :label="$t('SeaExport.CheckingStatus')" class="red">
              <el-input :value="lblCfrState" :disabled="true" style="flex: 1" />
            </el-form-item>
            <!-- 提单签发状态 -->
            <el-form-item :label="$t('SeaExport.BillLadingIssued')" class="red">
              <el-input :value="billLadingIssued" :disabled="true" />
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="section">
        <span class="title">{{ $t('SeaExport.BillOfLadingPackingInfo') }}</span>
        <div style="display:flex;flex-direction:column">
          <div v-show="isEdit" style="padding:5px 0">
            <el-button no="AddPackingInfo" type="primary" :disabled="!btnContainerEnable" @click="pm.addContainerUsageClickHandler()">{{ $t('SeaExport.AddPackingInfo') }}</el-button>
            <el-button no="RemovePackingInfo" type="primary" :disabled="!btnContainerEnable" @click="pm.removeContainerUsageClickHandler()">{{ $t('SeaExport.RemovePackingInfo') }}</el-button>
          </div>
          <cargo-ag-grid
            no="BillOfLadingPackingInfo"
            :grid-options="container.gridOptions"
            :column-defs="containerColumnDefs"
            :row-data="ediContainerFinalRowData"
            style="width:100%;height:350px"
            @gridReady="params=>{container.gridApi=params.api}"
          />
        </div>
      </div>
    </div>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :disabled="readonly"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button v-show="isEdit" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :job="job"
      :params="billAddressDialog.params"
      @callback="codeSearchCallback"
    />
    <!-- 工作单检索弹窗 -->
    <job-no-transcribe-dialog
      :visible.sync="searchBillNoDialog.visible"
      :params="searchBillNoDialog.params"
      @selected="searchBillNoDialog.selectHandler"
    />
    <!-- 抄录弹窗 -->
    <transcribe-dialog
      :visible.sync="transcribeDialog.visible"
      :job="job"
      @callback="transcribeCallback"
    />
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
      :return-main-callback="returnMainCallback"
    />
    <!-- 选择装箱信息弹窗 -->
    <add-cargo-doc-container-dialog
      :visible.sync="cargoDocUsageSelectedDialog.visible"
      :job="job"
      :doc-type="CargoDocConsts.HBL2"
      :cargo-docs="billFinalRowData"
      page-source="subBill"
      @callback="cargoDocUsageSelectedDialog.callback"
    />
  </div>
</template>

<script>
import { TabSubBillPM } from './tabSubBillPM'

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import billAddressDialog from '@/components/Cargo/Job/billAddressDialog'
import jobNoTranscribeDialog from '@/components/Cargo/Job/jobNoTranscribeDialog'
import transcribeDialog from '@/components/Cargo/Job/transcribeDialog'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import moment from 'moment'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import strUtils from '@/utils/StrUtils'
import { ensureExecuteSuccess, AutoIncrementNum } from '@/utils/commonUtil'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import CargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { formatNumberToThousands } from '@/utils'
import ColumnUtils from '@/utils/ColumnUtils'
import OperationRender from '@/components/OperationRender/index'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import AddCargoDocContainerDialog from '@/views/cargo/v0/SeaExport/components/booking/AddCargoDocContainerDialog'
import * as VirtualBillType from '@/class/cargo/model/parameters/VirtualBillType'
import { VIRTUAL_BILL_TYPES } from '@/class/cargo/model/parameters/VirtualBillType'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import { PrintUtils } from '@/utils/PrintUtils'
import { INTELLIGENT_DOCUMENT_SOURCE_16 } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'TabSubBill',
  components: {
    CargoRichTextarea, AutoNumberInput,
    cargoAdvanceSelect, cargoInput, cargoPackingSelect, billAddressDialog,
    jobNoTranscribeDialog, transcribeDialog, cargoTemplateSelectorDialog,
    AddCargoDocContainerDialog
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false, // 先隐藏，避免组件在初始化完成前，做一些无效的处理（频繁刷新组件、调用接口等）
      pm: new TabSubBillPM(this),
      moment,
      TYPE_NAMES,
      VIRTUAL_BILL_TYPES,
      VirtualBillType,
      CargoDocUtil,
      maxChars: 34,
      isUppercase: true,
      blModeList: [
        { serialNumber: 1, code: 'ORIGINAL', name: 'ORIGINAL', localName: this.$t('SeaExport.OriginalNormal') },
        { serialNumber: 2, code: 'SURRENDERED', name: 'SURRENDERED', localName: this.$t('SeaExport.TelexRelease') },
        { serialNumber: 3, code: 'SEA WAYBILL', name: 'SEA WAYBILL', localName: this.$t('SeaExport.TelexRelease') }
      ],
      btnPrintDisabled: true,
      job: {},
      command1: this.$t('SeaExport.CodeSearching'),
      form: new SeaCargoDoc().fillDefaultValue().getData(),
      command3: this.$t('SeaExport.CopyMblConsignee'),
      hblNoDisabled: true,
      txtFirstVesselVoyage: '',
      defaultIssuerBL: '',
      bill: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          singleClickEdit: true,
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor
          },
          context: {
            componentParent: this
          },
          onRowDataChanged: event => {
            // 清除单选行
            event.api.clearFocusedCell()
            this.bill.isSelected = false
          },
          onRowClicked: event => { this.curBill = event.data; this.pm.dgBill_changeHandler(event.data) }
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.BlSplitList'),
            colId: 'hblNbr2',
            field: 'hblNbr2',
            width: 294
          }, {
            headerName: this.$t('SeaExport.NumberOfPackagesOnBl'),
            colId: 'quantity',
            field: 'quantity',
            width: 100,
            hide: true,
            valueFormatter: (params) => {
              return (!params.value || isNaN(params.value) || Number(params.value) === 0) ? '' : params.value
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_InsideQuantity'),
            colId: 'insideQuantity',
            field: 'insideQuantity',
            width: 100,
            hide: true,
            valueFormatter: (params) => {
              return (!params.value || isNaN(params.value) || Number(params.value) === 0) ? '' : params.value
            }
          }, {
            headerName: this.$t('SeaExport.Weight'),
            colId: 'weight',
            field: 'weight',
            width: 100,
            hide: true
          }, {
            headerName: this.$t('SeaExport.Cubage'),
            colId: 'cubage',
            field: 'cubage',
            width: 100,
            hide: true
          }, {
            headerName: this.$t('SeaExport.HBLRefNo2'),
            colId: 'hblRefNo',
            field: 'hblRefNo',
            width: 200,
            hide: true,
            initialWidth: 180,
            editable: () => !this.readonly,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: (params) => ({
              selectProps: {
                tagValue: 'code',
                tagName: 'code',
                staticOptions: this.hblNoList,
                filterable: true
              }
            }),
            initialHide: false,
            valueFormatter: (params) => {
              return params.value
            },
            onCellValueChanged: p => this.pm.onCellChange(p)
          }
        ],
        rowData: [],
        gridApi: null,
        isSelected: false
      },
      // 形式分单并单
      virtualMergeBill: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          context: {
            componentParent: this
          },
          onRowDataChanged: event => {
            // 清除单选行
            event.api.clearFocusedCell()
            this.virtualMergeBill.isSelected = false
          }
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.BusinessNo'),
            colId: 'jobNo',
            field: 'jobNo',
            width: 109
          },
          {
            headerName: this.$t('SeaExport.Mbl2'),
            colId: 'mbl',
            field: 'mbl',
            width: 109
          },
          {
            headerName: this.$t('SeaExport.Quantity'),
            colId: 'quantityActual',
            field: 'quantityActual',
            width: 85
          },
          {
            headerName: this.$t('SeaExport.Weight'),
            colId: 'weightActual',
            field: 'weightActual',
            width: 85
          },
          {
            headerName: this.$t('SeaExport.Cubage'),
            colId: 'cubageActual',
            field: 'cubageActual',
            width: 85
          },
          {
            headerName: 'SO No.',
            colId: 'soNo',
            field: 'soNo',
            width: 85
          }
        ],
        rowData: [],
        gridApi: null,
        isSelected: false
      },
      addJoinMergeJobList: [], // 当前添加的并单（未保存）
      cmbtypeHAWB2Disabled: false,
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0, autoUppercase: false, autoHalfWord: false
        }
      },
      billAddressDialog: {
        visible: false,
        params: {
          shipperCode: '',
          consigneeCode: '',
          notifyCode: '',
          mbl: false
        }
      },
      searchBillNoDialog: {
        visible: false,
        params: {},
        selectHandler: () => { }
      },
      transcribeDialog: {
        visible: false
      },
      templateSelectorDialog: {
        visible: false,
        ctx: new SeaCargoDoc(),
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      returnMainCallback: null, // V1模板返回主页面回调事件
      curBill: null,
      autoIncrementNum: new AutoIncrementNum(),
      container: {
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          singleClickEdit: true,
          rowHeight: 32,
          onRowDataChanged: event => {
            event.api.clearFocusedCell()
          },
          context: {
            componentParent: this
          },
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridCommonInputEditor
          }
        },
        rowData: [],
        gridApi: null
      },
      cargoDocUsageSelectedDialog: {
        visible: false,
        callback: rows => {
          this.pm.usageSelectCallBackFunc(rows)
        }
      },
      CargoDocConsts,
      hblNoList: [],
      lblCfrState: '',
      billLadingIssued: '',
      isXy: false,
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return !this.isEdit
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look' && (!this.form.uuid || this.form.state < 2)
    },
    txtQuantitySum() {
      if (this.form && this.form.packing) {
        const packing = this.context.packingList.find(p => p.code === this.form.packing)
        if (packing) {
          return strUtils.jsdx(this.form.quantity, packing.name)
        }
      }
      return ''
    },
    billFinalRowData() {
      return this.bill.rowData.filter(p => !p.deleted).sort((a, b) => {
        const suffixA = a.hblNbr2.replace(`${this.job.jobNo}`, '')
        const suffixB = b.hblNbr2.replace(`${this.job.jobNo}`, '')
        return suffixA - suffixB
      })
    },
    virtualMergeBillFinalRowData() {
      return (this.virtualMergeBill.rowData) ? this.virtualMergeBill.rowData.filter(p => !p.deleted) : []
    },
    containerColumnDefs() {
      return [
        {
          headerName: '',
          colId: 'uuid',
          field: '',
          width: 40,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('SeaExport.ContainerSize'),
          colId: 'eqSize',
          field: 'eqSize',
          width: 160
        }, {
          headerName: this.$t('SeaExport.ContainerType'),
          colId: 'eqType',
          field: 'eqType',
          width: 160
        }, {
          headerName: this.$t('SeaExport.ContainerNo'),
          colId: 'containerNo',
          field: 'containerNo',
          width: 160
        }, {
          headerName: this.$t('SeaExport.SealNo'),
          colId: 'sealNo',
          field: 'sealNo',
          width: 160
        }, {
          headerName: this.$t('SeaExport.Quantity'),
          colId: 'quantity',
          field: 'quantity',
          width: 160,
          cellStyle: (params) => {
            return ContainerUtil.containerPushDataStyleFunction2(params, 'quantity')
          },
          valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 0, true), 2),
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 0
            }
          },
          onCellValueChanged: p => this.containerRowDataChanged(p)
        }, {
          headerName: this.$t('SeaExport.Weight'),
          colId: 'weight',
          field: 'weight',
          width: 160,
          cellStyle: (params) => {
            return ContainerUtil.containerPushDataStyleFunction2(params, 'weight')
          },
          valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 3
            }
          },
          onCellValueChanged: p => this.containerRowDataChanged(p)
        }, {
          headerName: this.$t('SeaExport.Cubage'),
          colId: 'cubage',
          field: 'cubage',
          width: 160,
          cellStyle: (params) => {
            return ContainerUtil.containerPushDataStyleFunction2(params, 'cubage')
          },
          valueFormatter: params => formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 3, true)),
          editable: this.isEdit,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 3
            }
          },
          onCellValueChanged: p => this.containerRowDataChanged(p)
        },
        {
          headerName: this.$t('SeaExport.Operation'),
          field: 'subItemNo',
          colId: 'subItemNo',
          width: 150,
          hide: !this.poItemsTabViewModel,
          cellStyle: { textAlign: 'center' },
          cellRendererFramework: OperationRender,
          cellRendererParams: {
            operations: [
              {
                title: this.$t('SeaExport.View') + '/' + this.$t('SeaExport.Edit'),
                type: 'primary',
                cssStyle: 'text-decoration: underline; color: #1605FB',
                onClick: (params) => {
                  this.checkAndEditClickHandler(params)
                },
                visible: (params) => this.poItemsTabViewModel
              }
            ]
          }
        }
      ]
    },
    ediContainerFinalRowData() {
      return this.container.rowData.filter(p => !p.deleted)
    },
    btnContainerEnable() {
      return this.billFinalRowData && this.billFinalRowData.length > 0
    }
  },
  async created() {
    await this.context.prepareData()
    this.notUppercaseShipperConsigneNotify = Number(this.context.config.get('NotUppercaseShipperConsigneNotify')) !== 1
    this.isUppercaseByConfig = Number(this.context.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    this.isXy = String(this.context.config.get('ToExoSystem')) === 'XYCW'
    this.visible = true
  },
  mounted() {
    ensureExecuteSuccess(() => this.$refs.orderFormType).then(() => {
      const options = this.$refs.orderFormType.options
      if (options[0] && options[0].uuid) {
        this.defaultIssuerBL = options[0].code
      } else if (options[1]) {
        this.defaultIssuerBL = options[1].code
      }
    })
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      if (!this.defaultIssuerBL) {
        await ensureExecuteSuccess(() => this.$refs.orderFormType)
        const options = this.$refs.orderFormType.options
        if (options[0] && options[0].uuid) {
          this.defaultIssuerBL = options[0].code
        } else if (options[1]) {
          this.defaultIssuerBL = options[1].code
        }
      }
      this.addJoinMergeJobList = []
      this.job = row
      // 先加载一遍cargoDoc
      await new SeaExportJob(this.job).getSeaCargoDoc()
      if (this.job.typeVirtualHbl === VirtualBillType.MERGE_VIRTUAL_BILL_TYPE.code) { // 并单
        await this.pm.loadByMerge()
      } else { // 普单
        await this.pm.loadByNormal()
      }
    },
    getSubmitData() {
      let seaCargoDoc = []
      if (this.job.typeVirtualHbl === VirtualBillType.NORMAL_VIRTUAL_BILL_TYPE.code) {
        const uuidList = []
        for (const item of this.bill.rowData) {
          this.validateRequire(item)
          this.pm.validateForm(item)
          this.pm.fillModel(item)
          if (item.uuid) {
            uuidList.push(item)
          }
        }
        seaCargoDoc = seaCargoDoc.concat(this.bill.rowData)
        // 由并单到普单，需要把原有的普单删除数据提交一下
        if (this.job.seaCargoDoc && this.job.seaCargoDoc.length > 0) {
          for (const item of this.job.seaCargoDoc) {
            if (item.docType === CargoDocConsts.HAWB2 && item.uuid && item.deleted && !uuidList.includes(item.uuid)) {
              seaCargoDoc.push(item)
            }
          }
        }
      } else if (this.job.typeVirtualHbl === VirtualBillType.MERGE_VIRTUAL_BILL_TYPE.code) {
        seaCargoDoc = []
        if (!this.form.docType) {
          this.form.docType = CargoDocConsts.HAWB2
        }
        this.validateRequire(this.form)
        seaCargoDoc.push(this.form)
        // 由普单变更为并单，需要把原有的普单删除数据提交一下
        if (this.job.seaCargoDoc && this.job.seaCargoDoc.length > 0) {
          for (const item of this.job.seaCargoDoc) {
            if (item.docType === CargoDocConsts.HAWB2 && item.uuid && item.deleted) {
              seaCargoDoc.push(item)
            }
          }
        }
      }
      return {
        job: this.job,
        seaCargoDoc: seaCargoDoc,
        hawb2JoinMergeJobList: this.addJoinMergeJobList
      }
    },
    validateRequire(cargoDoc) {
      // UI自定义中用到
    },
    commandHandle(command) {
      switch (command) {
        case this.$t('SeaExport.CodeSearching'):
          this.billAddressDialog.visible = true
          this.billAddressDialog.params.shipperCode = this.form.shipperCode
          this.billAddressDialog.params.consigneeCode = this.form.consigneeCode
          this.billAddressDialog.params.notifyCode = this.form.notifyCode
          // this.billAddressDialog.params.mbl = this.form.docType === 'MBL' || this.form.docType === 'MBL2'
          break
        case this.$t('SeaExport.CopyFromTheLastTime'):
          this.pm.onCopy1()
          break
        case this.$t('SeaExport.CopyFromOtherBill'):
          Object.assign(this.searchBillNoDialog.params, {
            docType: 'HAWB2',
            selectType: 'single',
            job: this.job
          })
          this.searchBillNoDialog.selectHandler = p => {
            this.pm.selectionItemHandler(p)
          }
          this.searchBillNoDialog.visible = true
          break
        case this.$t('SeaExport.CopyCargoDescriptionAndMarks'):
          this.transcribeDialog.visible = true
          break
        case this.$t('SeaExport.CopyMblConsignee'):
          this.pm.onCopy_agentParty()
          break
        case this.$t('SeaExport.CopyNominatedAgentInfo'):
          this.pm.onCopy_designationAgent()
          break
      }
    },
    onIdentificationList() {
      this.$router.push({
        name: 'OcrRecognition',
        query: {
          uuid: this.job.uuid,
          docUuid: this.form.uuid,
          source: INTELLIGENT_DOCUMENT_SOURCE_16.code
        }
      })
    },
    codeSearchCallback(data) {
      if (data.shipperInfo) {
        this.splitShipperLine(data.shipperInfo)
      }
      if (data.consigneeInfo) {
        this.splitConsigneeLine(data.consigneeInfo)
      }
      if (data.notifyInfo) {
        this.splitNotifyLine(data.notifyInfo)
      }
    },
    mergeShipperLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['shipperLine' + i] || ''
        result += '\n'
      }
      return result + (this.form['shipperLine7'] || '')
    },
    splitShipperLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['shipperLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['shipperLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['shipperLine' + i] = ''
      }
    },
    mergeConsigneeLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['consigneeLine' + i] || ''
        result += '\n'
      }
      return result + (this.form['consigneeLine7'] || '')
    },
    splitConsigneeLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['consigneeLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['consigneeLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['consigneeLine' + i] = ''
      }
    },
    mergeNotifyLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['notifyLine' + i] || ''
        result += '\n'
      }
      return result + (this.form['notifyLine7'] || '')
    },
    splitNotifyLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['notifyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['notifyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['notifyLine' + i] = ''
      }
    },
    mergeAgentPartyLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['agentPartyLine' + i] || ''
        result += '\n'
      }
      return result + (this.form['agentPartyLine7'] || '')
    },
    splitAgentPartyLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['agentPartyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['agentPartyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['agentPartyLine' + i] = ''
      }
    },
    showShipperDialog() {
      this.showAdvanceTextDialog(this.$t('SeaExport.Shipper'), this.mergeShipperLine(), this.splitShipperLine, this.notUppercaseShipperConsigneNotify, {
        autoUppercase: this.notUppercaseShipperConsigneNotify, autoHalfWord: true
      })
    },
    showConsigneeDialog() {
      this.showAdvanceTextDialog(this.$t('SeaExport.Consignee'), this.mergeConsigneeLine(), this.splitConsigneeLine, this.notUppercaseShipperConsigneNotify, {
        autoUppercase: this.notUppercaseShipperConsigneNotify, autoHalfWord: true
      })
    },
    showNotifyDialog() {
      this.showAdvanceTextDialog(this.$t('SeaExport.NotifyParty'), this.mergeNotifyLine(), this.splitNotifyLine, this.notUppercaseShipperConsigneNotify, {
        autoUppercase: this.notUppercaseShipperConsigneNotify, autoHalfWord: true
      })
    },
    showAgentPartyDialog() {
      this.showAdvanceTextDialog(this.$t('SeaExport.AgentInfo'), this.mergeAgentPartyLine(), this.splitAgentPartyLine, true, {
        autoUppercase: true, autoHalfWord: true
      })
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false, formatObj = null) {
      const defaultFormatObj = {
        warningCount: -1,
        maxChar: 0, autoUppercase: true, autoHalfWord: true
      }
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      this.advanceTextDialog.visible = true
      this.$nextTick(() => {
        this.$refs.advanceTextDialogTextarea.editor.focus()
      })
      this.advanceTextDialog.formatObj = formatObj ? { ...defaultFormatObj, ...formatObj } : defaultFormatObj
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    transcribeCallback(data) {
      if (data.hasOwnProperty('cargoEnglishName')) {
        this.form.cargoEnglishName = data.cargoEnglishName
      }
      if (data.hasOwnProperty('mark')) {
        this.form.mark = data.mark
      }
    },
    /**
     * 正本打印
     */
    originalPrint() {
      if (this.pm.originalPrintCheckSerialNo && this.form.releaseType === 1 && !this.form.serialNo) {
        this.$message.info(this.$t('Message.PleaseEnterTheBillOfLadingSerialNumber'))
        return
      }
      // this.pm.issuedBL()
      const params = {}
      params.cargoDocUuid = this.form.uuid
      params.jobuuid = this.job.uuid
      params.DOC_UUID = this.form.uuid
      params.hblNo = this.form.hblNbr2
      params.hblRefNo = this.form.hblRefNo
      params.subBill = 1
      params.subBillUuid = this.form.uuid
      // CARGO-6750，SOP回调cargo失败。UUID中有 /导致url匹配不上了
      params.printCallBackUrl = 'services/printExec/entity/update2/CargoDoc?key=' + encodeURIComponent(this.form.uuid) + '&fieldCount=1&field1=state&value1=2'
      if (this.form.releaseType === 1) {
        this.templateSelectorDialog.ctx = new SeaCargoDoc(this.form)
        this.templateSelectorDialog.category = 'HBLZB'
        this.templateSelectorDialog.data = params
        // 组装打印回调函数
        this.prePrintCallback = null
        // CARGO-16750 HBL正本或电放打印 V1模板也增加“是否打印成功”选项
        this.printedCallback = null
        this.returnMainCallback = event => {
          this.pm.print_callback(event)
        }
        this.v2CheckCallback = async(isSure, template, entity, arms) => {
          await this.pm.v2CheckCallbackFun2(isSure, template, entity, arms)
        }
        this.templateSelectorDialog.visible = true
      } else {
        this.templateSelectorDialog.ctx = new SeaCargoDoc(this.form)
        this.templateSelectorDialog.category = 'HBLDF'
        this.templateSelectorDialog.data = params
        // 组装打印回调函数
        this.prePrintCallback = null
        // CARGO-16750 HBL正本或电放打印 V1模板也增加“是否打印成功”选项
        this.printedCallback = null
        this.returnMainCallback = event => {
          this.pm.print_callback(event)
        }
        this.v2CheckCallback = (isSure, template, entity, arms) => {
          this.pm.v2CheckCallbackFun2(isSure, template, entity, arms)
        }
        this.templateSelectorDialog.visible = true
      }
    },
    // 组装打印参数
    getPrintData() {
      if (this.job) {
        if (!this.form.jobUuid) {
          this.form.jobUuid = this.job.uuid
        }
        const params = {}
        params.jobuuid = this.job.uuid
        params.cargoDocUuid = this.form.uuid
        params.DOC_UUID = this.form.uuid
        params.category = 'HBL'
        params.subBill = 1
        params.subBillUuid = this.form.uuid
        params.ctx = new SeaCargoDoc(this.form)
        return params
        // TemplateSelectorWin.getInstance().showThisWin(view.cargoDoc, 'HBL', params, view)
      }
    },
    hblNbr2Change() {
      const { gridApi } = this.bill
      if (gridApi) {
        gridApi.refreshCells()
        this.$nextTick(() => {
          if (this.curBill) {
            const temporarySerialNumber = this.curBill.temporarySerialNumber
            if (this.bill.rowData && this.bill.rowData.length > 0) {
              for (const doc of this.bill.rowData) {
                if (doc.temporarySerialNumber === temporarySerialNumber) {
                  doc.hblNbr2 = this.form.hblNbr2
                }
              }
            }
            this.curBill.hblNbr2 = this.form.hblNbr2
            const { rowsToDisplay } = gridApi.getModel()
            const selectedNode = rowsToDisplay.find(node => node.data.hblNbr2 === this.curBill.hblNbr2)
            selectedNode.setSelected(true)
          }
        })
      }
    },
    containerRowDataChanged(params) {
      if (this.isXy) {
        return
      }
      // 值未变更的情况下不用重新计算
      if (Number(params.newValue) === Number(params.oldValue)) return
      const { field } = params.colDef
      let sum = 0
      for (const item of this.container.rowData) {
        sum += Number(item[field])
      }
      this.form[field] = sum
      CargoDocUtil.calculateSEChargeWeight(this.form)
    }
  }
}
</script>

<style lang="scss">

</style>
